import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import cn from 'classnames';
import style from './Layout.module.scss';
import { useState, useEffect } from 'react';
import { Theme, Footer as LayoutFooter } from '../../constant/appearance';
import { config } from '../../config';
import { Header } from '../Header';
import { Language } from '../../constant/localization';
import Footer from 'components/Footer/Footer';

const LayoutNameSpace = ['common'];

interface LayoutProps {
  children: ReactNode;
  theme?: Theme;
  showFooter?: boolean;
  footer?: LayoutFooter;
  payee?: string;
}

const Layout = (props: LayoutProps) => {
  const { theme, children, showFooter = true } = props;
  const { t, i18n } = useTranslation(LayoutNameSpace);
  const { language = config.DEFAULT_LOCALE } = i18n;

  const onChangeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  useEffect(() => {
    document.title = t('title');
  }, [language]);

  const [footer, setFooter] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setFooter(true);
    }, 800);
  }, []);

  const currentLanguage = (config.AVAILABLE_LOCALES.includes(language)
    ? language
    : config.DEFAULT_LOCALE
  ) as Language;

  return (
    <div className={cn(style[`lang${language.toUpperCase()}`], style.container)}>
      <header>
        <Header
          theme='white' onChangeLanguage={onChangeLanguage}
          language={currentLanguage}
          type='simple'
          showSwitchLanguage
          availableLanguages={config.AVAILABLE_LOCALES as Language[]}
        />
      </header>
      <div className={style.contain}>
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
